/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const ComputeResourceType = {
  Job: "job",
  Service: "service",
} as const;
export type ComputeResourceType = ClosedEnum<typeof ComputeResourceType>;

/** @internal */
export const ComputeResourceType$inboundSchema: z.ZodNativeEnum<
  typeof ComputeResourceType
> = z.nativeEnum(ComputeResourceType);
/** @internal */
export const ComputeResourceType$outboundSchema: z.ZodNativeEnum<
  typeof ComputeResourceType
> = ComputeResourceType$inboundSchema;
